import { Location } from '../helpers/LocationHelper'
import { GetCookie, SetCookie } from '../helpers/CookieHelper'

export const LocationService = () => {
    let promise;
    let geolocation;
    const geolocationCookie = 'geolocation'
    const geolocationData = GetCookie(geolocationCookie)

    if (geolocationData != undefined) {
        geolocation = JSON.parse(geolocationData)
        promise = new Promise((resolve) => {
            resolve(geolocation)
        })
    } else {
        promise = Location().then((data) => {
            geolocation = {
                zipCode: data.zipCode,
                cityName: data.cityName,
                countryCode: data.countryCode
            }
            SetCookie(geolocationCookie, JSON.stringify(geolocation), 365)
            return data
        })
    }

    return promise;
}